import { Star } from "lucide-react";

/**
 * Display star rating (read-only or interactive).
 * Props:
 * - value: number (0..5, supports halves)
 * - size: number (icon px size, default 14)
 * - onChange: (n: number) => void  → if provided, becomes interactive
 * - className: optional wrapper class
 */
export default function Stars({ value = 0, size = 14, onChange, className = "" }) {
  const interactive = typeof onChange === "function";
  const stars = [1, 2, 3, 4, 5];
  return (
    <div
      className={`inline-flex items-center gap-0.5 ${className}`}
      data-testid="stars"
    >
      {stars.map((n) => {
        const filled = value >= n - 0.25;
        const half = !filled && value >= n - 0.75;
        return (
          <button
            key={n}
            type="button"
            onClick={interactive ? () => onChange(n) : undefined}
            disabled={!interactive}
            aria-label={`${n} étoile${n > 1 ? "s" : ""}`}
            data-testid={`star-${n}`}
            className={`${
              interactive
                ? "cursor-pointer hover:scale-110 transition"
                : "cursor-default"
            } leading-none`}
            style={{ background: "none", border: 0, padding: 0 }}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              className={
                filled
                  ? "fill-yellow-300 text-yellow-300"
                  : half
                  ? "fill-yellow-300/50 text-yellow-300"
                  : "fill-transparent text-white/30"
              }
            />
          </button>
        );
      })}
    </div>
  );
}
